import { IonButton, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow, IonText } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { OptionPages } from '../../models/apiModels';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchOptions } from '../../services/options_service';

interface HomeProps {
  user?: User | null,
  lan: string
}


const SwFundraiser: React.FC<HomeProps> = (props) => {

  const siteText = translation();

  const [siteOptions, setSiteOptions] = useState<OptionPages>();

  useEffect(() => {
    getOptions()
  }, []);

  const getOptions = async () => {
    let resp: any = await fetchOptions();
    if (!resp.error) {
      let options: OptionPages = resp.message;
      setSiteOptions(options);
    }
  }


  const svgUrl = `${process.env.PUBLIC_URL}/assets/svg/`;
  return (
    <IonPage>
      <Header user={props.user} />
      <IonContent>

        {siteText.lan.indexOf('en') > 0 &&
          <IonGrid className='sw_sp_lg'>
            <IonRow className='ion-justify-content-center ion-align-items-center'>
              <IonCol sizeSm='10' sizeMd="8">
                <IonRow className='ion-justify-content-center ion-align-items-center'>
                  <IonCol className='ion-text-center'>
                    < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                    <h1 >Help us help organisations by supporting the SwissDonations platform</h1>
                    <IonText>
                      <IonButton routerLink={props.lan + "/support_us_donate"}>
                        DONATE
                      </IonButton>
                    </IonText>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol className='sw_mb_sm'>
                    <h2>Dear friends,</h2>
                    <p>We are launching SwissDonations, a new digital platform to facilitate and increase donations in Switzerland while offering a better visibility to non-profit organisations.</p>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol>
                    <h2>Our objective is threefold:</h2>
                    <ul>
                      <li>To encourage people to donate to local charities.</li>
                      <li>To help Swiss charities raise more funds.</li>
                      <li>To capitalize on the increase of digital donations.</li>
                    </ul>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol className='ion-text-center'>
                    <h2>Support us so we can support other charities!</h2>
                    <p className=''>SwissDonations is a non-profit organisation, tax-exempted by the Canton of Geneva. You can therefore donate directly to SwissDonations, it will be deductible from your taxes. </p>
                    <p className='ion-text-start'>We will use this donation to:</p>
                    <ul className='ion-text-start'>
                      <li>Grow our activity, in particular engaging with non-profit organisations </li>
                      <li>Develop our digital platform. At the moment, we are still doing a lot of operations manually, behind the web page! </li>
                    </ul>
                    <p className='sw_mt_lg'>You will therefore help us (a little or a lot) so we can help even more!   </p>
                    <IonButton routerLink={props.lan + "/support_us_donate"}>I donate to SwissDonations! </IonButton>
                    <p className='sw_mt_lg'>If you are interested in our project, want to help us or just have a question, please contact us at info@swissdonations.ch</p>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <p>Thank you!</p>
                    <p>The SwissDonations team</p>
                  </IonCol>
                </IonRow>




              </IonCol>
            </IonRow>
          </IonGrid>}
        {siteText.lan.indexOf('fr') > 0 &&
          <IonGrid className='sw_sp_lg'>
            <IonRow className='ion-justify-content-center ion-align-items-center'>
              <IonCol sizeSm='10' sizeMd="8">
                <IonRow className='ion-justify-content-center ion-align-items-center'>
                  <IonCol className='ion-text-center'>
                    < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                    <h1 >Aidez-nous à aider les associations en soutenant la plateforme SwissDonations</h1>
                    <IonText>
                      <IonButton routerLink={props.lan + "/support_us_donate"}>
                        DONNEZ
                      </IonButton>
                    </IonText>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol className='sw_mb_sm'>
                    <h2>Chers donateurs, chers amis,</h2>
                    <p>Nous lançons SwissDonations, une nouvelle plateforme numérique pour faciliter et augmenter les dons en Suisse tout en offrant une meilleure visibilité aux associations.</p>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol>
                    <h2>Notre objectif est triple :</h2>
                    <ul>
                      <li>Encourager la population à donner aux associations locales.</li>
                      <li>Aider les associations suisses à lever plus de fonds.</li>
                      <li>Faire profiter les donateurs et associations des avancées numériques.</li>
                    </ul>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol className='ion-text-center'>
                    <h2>Vous pouvez nous aider à aider !</h2>
                    <p>SwissDonations est une association à but non-lucratif, exonérée de l’impôt par le canton de Genève. Vous pouvez donc faire un don directement à SwissDonations, il sera déductible de vos impôts.</p>
                    <p className='ion-text-start'>Nous utiliserons ce don pour:</p>
                    <ul className='ion-text-start'>
                      <li>Soutenir notre activité en cours de développement, notamment la connexion avec les associations </li>
                      <li>Développer et automatiser notre plateforme numérique. Pour le moment, nous effectuons encore beaucoup d’opération manuellement, derrière la page internet ! </li>
                    </ul>
                    <p className='sw_mt_lg'>Vous allez donc nous aider (un peu ou beaucoup) afin que nous puissions aider encore plus ! </p>
                    <IonButton routerLink={props.lan + "/support_us_donate"}>Je fais un don à SwissDonations  </IonButton>
                    <p className='sw_mt_lg'>Si notre projet vous intéresse, que vous voulez nous aider ou juste nous poser une question, n’hésitez pas à nous contacter à info@swissdonations.ch</p>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <p>Merci !</p>
                    <p>L’équipe de SwissDonations</p>
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>}
        {siteText.lan.indexOf('de') > 0 &&
          <IonGrid className='sw_sp_lg'>
            <IonRow className='ion-justify-content-center ion-align-items-center'>
              <IonCol sizeSm='10' sizeMd="8">
                <IonRow className='ion-justify-content-center ion-align-items-center'>
                  <IonCol className='ion-text-center'>
                    < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                    <h1 >Helfen Sie uns, gemeinnützige Organisationen zu unterstützen, indem Sie an die Plattform SwissDonations spenden</h1>
                    <IonText>
                      <IonButton routerLink={props.lan + "/support_us_donate"}>
                      SPENDEN
                      </IonButton>
                    </IonText>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol className='sw_mb_sm'>
                    <h3>Liebe Freunde, liebe Spenderinnen und Spender,</h3>
                    <p>Wir lancieren SwissDonations, eine neue digitale Plattform, um das Spenden in der Schweiz zu erleichtern und zu fördern und gleichzeitig den gemeinnützigen Organisationen eine bessere Visibilität zu verleihen.</p>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol>
                    <h2>Wir haben 3 Ziele: </h2>
                    <ul>
                      <li>Die Menschen zu motivieren, für lokale gemeinnützige Organisationen zu spenden.</li>
                      <li>Schweizerische gemeinnützige Organisationen bei ihrem Fundraising zu unterstützen.</li>
                      <li>Vom wachsenden Markt der digitalen Spenden zu profitieren.</li>
                    </ul>
                  </IonCol>
                </IonRow>
                <IonRow className='sw_mb_sm'>
                  <IonCol className='ion-text-center'>
                    <h2>Sie können uns helfen, zu helfen!</h2>
                    <p>SwissDonations ist eine Non-Profit-Organisation, die vom Kanton Genf steuerbefreit ist.  Sie können also direkt an uns spenden und Ihre Spende vom steuerbaren Einkommen abziehen. </p>
                    <p className='ion-text-start'>werden wie folgt verwendet: </p>
                    <ul className='ion-text-start'>
                      <li>Unterstützung zum Aufbau unserer Geschäftstätigkeit, insbesondere die Zusammenarbeit mit den gemeinnützigen Organisationen;</li>
                      <li>Entwicklung und Automatisierung unserer digitalen Plattform. Zurzeit sind viele Prozesse noch manuell gesteuert. </li>
                    </ul>
                    <p className='sw_mt_lg'>Helfen Sie uns also (ein wenig oder viel), damit wir noch mehr helfen können!  </p>
                    <IonButton routerLink={props.lan + "/support_us_donate"}>Ich spende an SwissDonations!</IonButton>
                    <p className='sw_mt_lg'>Wenn Sie sich für unser Projekt interessieren, uns helfen wollen oder einfach eine Frage haben, kontaktieren Sie uns bitte unter info@swissdonations.ch</p>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <p>Herzlichen Dank!</p>
                    <p>Das SwissDonations-Team</p>
                  </IonCol>
                </IonRow>




              </IonCol>
            </IonRow>
          </IonGrid>}

        <Footer></Footer>
      </IonContent>
    </IonPage>
  );
};

export default SwFundraiser;
